export default {
    router: {
        dashboard: "控制台"
    }
}